import React, {useEffect, useRef } from 'react';
import MaterialTable from 'material-table';
import { NavLink } from 'react-router-dom';
import { TablePagination } from '@material-ui/core';
import Cookies from 'js-cookie';
import CircularProgress from '@material-ui/core/CircularProgress';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes} from '@fortawesome/free-solid-svg-icons';
import { clearCookie } from '../../functions/Auth';
import { useHistory } from 'react-router-dom';
import { MoreVertRounded } from '@material-ui/icons';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';

import API_PATH from "../../constants/config.json";
import TableIcons from '../TableIcons';
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

let searchTerm = "";

const AllFiles = (props) =>{

    let history = useHistory();
    const [fileList, setFileList] = React.useState([]);
    const [pagination, setPagnation] = React.useState({ selectedPage: 1 });
    const [totalItems, setTotalItems] = React.useState(0);
    const [hover, setHower] = React.useState(false);
    const [getSearchTerm, setSearchTerm] = React.useState("");
    const refContainer = useRef('');
    const [getLoader, setLoaderDisable] = React.useState(false);
    const tableRef = useRef();

    const enteriesPerPage = 25;
    let values = {
        "pageNo": pagination.selectedPage,
        "entriesPerPage": enteriesPerPage,
    }

    useEffect(
        () => {
            if(props.needToReload)
                getFilesAPI(pagination.selectedPage);
        }, [props.needToReload]
    )

    const getFilesAPI = (page = 1, search = "", enable = false) => {
        setLoaderDisable(true);
        let enableV = search !== "" || searchTerm !== "" ? true : enable;
        try {
            axios({
                method: 'post',
                data: {
                    pageNo: page,
                    entriesPerPage: enteriesPerPage,
                    searchEnable: enableV,
                    searchValue: search !== "" ? search : searchTerm,
                    fileStatus: []
                },
                headers: {
                    'payload': Cookies.get('payload'),
                    'agencyid': sessionStorage.getItem('agency_id')
                },
                url: API_URL + API_PATH.getImportFilesAPIv2,
            })
                .then(async function (response) {
                    if (response.status && response.status == '200') {
                        let fileData = response.data.data.rows;
                        setLoaderDisable(false);                      
                        setFileList(fileData);
                        setTotalItems(response.data.data.count);
                    } else {
                        setFileList([]);
                        setLoaderDisable(false);
                    }
                })
                .catch(async function (error) {
                    setLoaderDisable(false);
                    if (error.response) {
                        if (error.response.status == '401') {
                            if (Cookies.get('email')) {
                                clearCookie('email');
                                clearCookie('payload');
                                clearCookie('idToken');
                                clearCookie('organization');
                                clearCookie('atexpiry');
                            }
                            history.push('/');
                        }
                    }
                })
        } catch (error) {
            console.error(error);
            setLoaderDisable(false);
        }
    }

    const handleSelected = (e, selectedPage) => {
        values.pageNo = selectedPage + 1;
        let page = values.pageNo
        setPagnation({ selectedPage: selectedPage + 1 })
        getFilesAPI(page);
    }

    const kekPressSearch = (e) => {    
        if(e.key === 'Enter'){
          e.preventDefault();
          onSearch();
        }    
    }

    const searchField = (e) => {
        setHower(true)    
        searchTerm = e.target.value;   
        getFilesAPI(1, e.target.value, true)
        setPagnation({ selectedPage: 1 })    
    }

    const onSearch = () => {   
        if(searchTerm == ''){      
            return;
        }
        getFilesAPI(1, searchTerm, true)
        setPagnation({ selectedPage: 1 })
    }

    const clearText = () => {
        refContainer.current.reset();
        searchTerm = "";
        getFilesAPI(1, "", false);
        setPagnation({ selectedPage: 1 })
    }

    return(
        <React.Fragment>  
            <div className="table-top">
                <h3>All storage files</h3>
                <form ref={refContainer} noValidate autoComplete="off">
                    <TextField
                    id="input-with-icon-textfield"
                    placeholder="Search"
                    onChange={(e) => searchField(e)}
                    onKeyPress={(e) => kekPressSearch(e)}
                    InputProps={{
                        startAdornment: (
                        <InputAdornment position="start" onClick={onSearch}>
                            <SearchIcon style={{ cursor: 'pointer' }} />
                        </InputAdornment>
                        ),
                        endAdornment: (
                        <InputAdornment position="end">
                            {hover && <FontAwesomeIcon icon={faTimes} onClick={clearText} />}
                        </InputAdornment>
                        ),
                    }}

                    />      
                    
                </form>
            </div>   
            <div className={props.scrolled ? "table-container scrolled-el" : "table-container"} onScroll={() => props.handleScroll(tableRef)} ref={tableRef}>
                <MaterialTable
                    icons={TableIcons}
                    title=""
                    columns={[
                    { title: 'Station ID', field: 'client_station_id', width: '15%',
                        render: rowData => 
                        <NavLink to="#" onClick={() => props.handleGoToDetails(rowData)}>
                            <label title={rowData.client_station_id}>{rowData.client_station_id.length > 15 ? rowData.client_station_id.substring(0, 14)+'...' : rowData.client_station_id}</label>
                        </NavLink> 
                    },
                    { title: 'File name', field: 'filename', width: '30%',
                        render: rowData => {
                            return <>
                            {
                                rowData.bucket_name === 'N/A' || !rowData.bucket_name || rowData.bucket_name === '' ?
                                <NavLink to="#">
                                    <label title={rowData.filename}>{rowData.filename.length > 32 ? rowData.filename.substring(0, 31)+'...' : rowData.filename}</label>
                                    {props.loader.filename === rowData.file_id && props.loader.loader ? <CircularProgress /> : null}
                                    </NavLink>  
                                :
                                <NavLink to="#" onClick={() => props.downloadFile(rowData.file_id, rowData.bucket_name, rowData.base_name, rowData.filename)}>
                                    <label title={rowData.filename}>{rowData.filename.length > 32 ? rowData.filename.substring(0, 31)+'...' : rowData.filename}</label>
                                    {props.loader.filename === rowData.file_id && props.loader.loader ? <CircularProgress /> : null}
                                </NavLink>  
                            }
                            </>
                        }
                    },
                    { title: 'Date', field: 'createdAt', width: '14%', 
                        render: rowData => {
                            var dt = new Date(rowData.createdAt);
                            let day = dt.getDate()<10?'0'+dt.getDate(): dt.getDate();
                            let month = (dt.getMonth()+1)<10 ? '0'+(dt.getMonth()+1) : dt.getMonth()+1;
                            return `${month}/${day}/${dt.getFullYear()}`;
                        }
                    },
                    { title: 'Status', field: 'status', width: '14%',
                        render: rowData => 
                        <label className={ rowData.status === 'Ready' || rowData.status === 'Rejected' ? rowData.status+'-status' : (rowData.is_public ? 'Shared-status' : 'Unshared-status') }>
                            {rowData.status === 'Ready' ? 'Pending' : rowData.status === 'Rejected' ? rowData.status : (rowData.is_public ? 'Shared' : 'Unshared') }
                        </label>
                    },
                    { title: 'Imported by', field: 'email', width: '20%', },
                    { title: 'Actions', field: '', width: '7%', cellStyle: { textAlign: 'center' },
                        render: rowData => 
                        <MoreVertRounded 
                            className={rowData.status==='Rejected' || rowData.bucket_name === 'N/A' || !rowData.bucket_name || rowData.bucket_name === '' ? "actions-dots-disabled" : "actions-dots"}
                            onClick={(e) => props.handleShowActions(e,rowData.file_id, rowData.status, rowData.is_public, rowData)} 
                        /> 
                    },
                    ]}
                    data={fileList ? fileList : []}
                    totalCount={totalItems}
                    options={{
                        filtering: false,
                        sorting: false,
                        // paging: true,
                        paging: totalItems > 25 ? true : false,
                        pageSize: enteriesPerPage,
                        pageSizeOptions: [0],
                        search:false,
                        emptyRowsWhenPaging: false,
                        draggable: false
                    }}
                    components={
                        getLoader == false ?
                        fileList.length === 0 ? 
                            { 
                                Body: () => (
                                    <tbody>
                                        <tr style={{ height: '380px' }}>
                                            <td colspan="7" className="empty-state">
                                                <img src={require('../../assets/icons/empty-files-table.svg')} />
                                                <label>No files here</label>
                                                <p>Once you upload some storage files they will appear here!</p>
                                            </td>
                                        </tr>
                                    </tbody>
                                )
                            } 
                            :
                            {
                                Pagination: props => (
                                    <TablePagination
                                    {...props}
                                    count={totalItems}
                                    page={pagination.selectedPage - 1}
                                    onChangePage={handleSelected}
                                    rowsPerPage={enteriesPerPage}
                                    />
                                ),
                            }
                        :
                        {
                            Pagination: props => (
                            <TablePagination
                                {...props}
                                count={totalItems}
                                page={pagination.selectedPage - 1}
                                onChangePage={handleSelected}
                                rowsPerPage={enteriesPerPage}
                            />
                            ),
                            Body: (props) => (
                            <tbody><tr style={{ height: '49px' }}><td colspan="7" style={{ width: '100%', paddingTop: '0px', paddingBottom: '0px', textAlign: 'center' }}><span style={{ color: '#CC0000', fontWeight: '600' }}><CircularProgress/></span> </td></tr></tbody>
                            )
                        }
                    }
                />
            </div>
        </React.Fragment>
    );
}
export default AllFiles;